const language = [
    {
        language: "Português",
        level: "10"
    },
    {
        language: "English",
        level: "6"
    },
    {
        language: "Español",
        level: "3"
    }
];

export default language;